module.exports = __webpack_public_path__ + "img/X_bright.2b64135d.svg";